import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/users/constants';

import { usersQueryKeys } from './queryKeys';

export const useWorkspaceUsersQuery = () => {
  return useQuery({
    queryKey: usersQueryKeys.workspace(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.workspaceUsers, {});
      return data;
    },
  });
};
